import { IPageInfo } from "../common.interface";
import { IProduct } from "../Product/product.interface";

export interface IDiscount {
    id: string;
    promoTag: string;
    productId: string | null;
    categoryId: string | null;
    name: string;
    value: number | string;
    discountType: string;
    targetType: string;
    status: 'active' | 'inactive' | null;
    startDate: string;
    endDate: string;
    createdAt: string;
    updatedAt: string;
    category: any | null;
    userId: string;
    products: {
        name: string;
        price: string;
        media: any[];
    }[] | null;
}

export enum PromoTag {
    TODAYS_SPECIAL = 'todays_special',
    WEEKEND_SPECIAL = 'weekend_special',
    SALE = 'sale',
    FESTIVE_OFFER = 'festive_offer',
    LIMITED_TIME_DEAL = 'limited_time_deal',
    TRENDING_DEAL = 'trending_deal',
}

export interface IAddDiscountForm {
    name: string;
    value: number;
    discountType: string;
    targetType: string;
    targetId: string;
    startDate: string;
    endDate: string;
    campaignType: string;
}

export interface IDiscountListResponse {
    data: {
        discounts: IDiscount[];
        pageInfo: IPageInfo;
    };
    message: string;
}

export interface ISingleDiscountResponse {
    data: IDiscount;
    message: string;
}
